import { Badge } from 'components/common';

interface Props {
  categories?: string[] | null;
}

const CategoryBadges = ({ categories }: Props) => {
  if (!categories?.length) return null;

  return (
    <div className="categories">
      {categories.map((category) => (
        <Badge key={category} size="small" text={category} />
      ))}

      <style jsx>{`
        .categories {
          display: flex;
          gap: 5px 10px;
          margin-top: 10px;
          overflow-y: auto;
        }
      `}</style>
    </div>
  );
};

export default CategoryBadges;
